import {Component, computed, inject, input, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Api} from '../../../../api/api';
import {getCurrentConsumptionPrice, getCurrentFeedInPrice} from '../../../../api/functions';
import {rxResource} from '@angular/core/rxjs-interop';
import {catchError, from, of} from 'rxjs';
import {LocationStateService} from '../../../../common/services/location-state.service';

export type EnergyPriceType = 'consumption' | 'feed-in';

@Component({
  selector: 'app-energy-price-current',
  imports: [CommonModule],
  templateUrl: './energy-price-current.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './energy-price-current.component.css',
})
export class EnergyPriceCurrentComponent {
  api = inject(Api);
  locationStateService = inject(LocationStateService);
  type = input.required<EnergyPriceType>();
  label = computed(() => (this.type() === 'consumption' ? 'Bezugspreis (inkl. Netz):' : 'Einspeisungspreis:'));
  params = computed(() => ({
    location_id: this.locationStateService.currentLocation()?.id ?? '',
    type: this.type(),
  }));
  resource = rxResource({
    params: this.params,
    stream: ({params}) => {
      const fn = params.type === 'consumption' ? getCurrentConsumptionPrice : getCurrentFeedInPrice;
      return from(this.api.invoke(fn, {location_id: params.location_id})).pipe(
        catchError((error) => {
          console.log('Energy price API does not respond.', error);
          return of(undefined);
        }),
      );
    },
  });
  // displayed in ct/kWh; the API converts the EUR/MWh price itself (1 EUR/MWh = 0.1 ct/kWh)
  priceCt = computed(() => {
    const price = this.resource.value();
    if (price?.valueCtPerKwh != null) {
      return price.valueCtPerKwh;
    }
    if (price?.value == null) {
      return undefined;
    }
    switch ((price.unit ?? '').toUpperCase()) {
      case 'EUR/MWH':
        return price.value / 10;
      case 'EUR/KWH':
        return price.value * 100;
      default:
        return price.value;
    }
  });
}
